module.exports = __webpack_public_path__ + "img/IND-A-1-III.ba957702.png";